<template>
    <div :class="`${className} row`">
        <div class="col-lg-12 form-group">
            <label for="referral-address-line-1"> <span v-if="isPrimaryAddress">Primary</span> Address Line 1 </label>
            <input
                class="form-control"
                maxlength="50"
                type="text"
                v-model="address.AddressLine1"
                @change="addressChanged('AddressLine1')"
                placeholder="Enter Address Line 1"
            />
        </div>
        <div class="col-lg-12 form-group">
            <label for="referral-address-line-2"><span v-if="isPrimaryAddress">Primary</span> Address Line 2 </label>
            <input
                class="form-control"
                maxlength="50"
                type="text"
                v-model="address.AddressLine2"
                @change="addressChanged('AddressLine2')"
                placeholder="Enter Address Line 2"
            />
        </div>
        <div class="col-lg-6 form-group">
            <label for="referral-zip"> <span class="badge me-1" v-if="showCode">M0060</span> Zip </label>
            <input
                class="form-control"
                maxlength="5"
                type="text"
                v-number-only
                v-model="address.AddressZipCode"
                @change="addressChanged('AddressZipCode')"
                placeholder="Enter Zip"
            />
        </div>
        <div class="col-lg-6 form-group" v-if="index == null && showCountyFrzip">
            <label for="referral-zip">ZIP-4 </label>
            <input
                class="form-control"
                maxlength="4"
                type="text"
                v-number-only
                v-model="address.AddressZipCodeFour"
                placeholder="Enter Zip"
                @change="addressChanged('AddressZipCodeFour')"
            />
        </div>
        <div class="col-lg-6 form-group" v-if="index == null && showCountyFrzip">
            <label for="referral-county"> County </label>
            <select class="form-select" @change="addressChanged('AddressCounty')" v-model="address.AddressCounty">
                <option value="" disabled hidden>Select County</option>
                <option v-if="countyData?.length" :value="ctyData" :key="index" v-for="(ctyData, index) in countyData">
                    {{ ctyData }}
                </option>
                <option v-else disabled :value="null">List is empty</option>
            </select>
        </div>
        <div class="col-lg-6 form-group">
            <label for="referral-city"> City </label>
            <input
                class="form-control"
                maxlength="50"
                type="text"
                @change="addressChanged('AddressCity')"
                v-model="address.AddressCity"
                placeholder="Enter City"
            />
        </div>
        <div class="col-lg-12 form-group">
            <label for="referral-state">
                <span class="badge me-1" v-if="showCode">M0050</span>
                State
            </label>
            <select class="form-select" @change="addressChanged('AddressStateCode')" v-model="address.AddressStateCode">
                <option selected value="">Select State</option>
                <option
                    :value="addState.value"
                    :key="index"
                    v-for="(addState, index) in referralOptions?.addressStateCode"
                >
                    {{ addState.text }}
                </option>
            </select>
        </div>
    </div>
</template>

<script lang="ts" src="./ReferralAddressForm.ts"></script>
